export default __webpack_public_path__ + "static/media/phones@2x.6afa4bac.png";